<template>
  <div class="container">
    <div class="privacy-policy-text" v-html="formatPrivacyPolicyText(privacyPolicyText)"></div>
  </div>
</template>

<script>
export default {
  name: "Rgpd",
  data() {
    return {
      title: "Politique de confidentialité de l'application mobile et le portail Mes Cantonnniers",
      privacyPolicyText: `Les données personnelles collectées dans le cadre du déploiement de l’application cantonniers font l’objet d’un traitement par Suez Recyclage et Valorisation France, responsable de traitement, dont le siège social est situé Tour CB21, 16 Place de l’Iris, 92040, Paris La Défense Cedex.\n\nLes traitements des données personnelles ont pour finalités de :\n<div style="margin-left: 4%" class="list-container">
        <em>- Identifier les besoins d'accompagnement, de soutien et de développement des opérationnels,</em>
        <em>- Identifier les zones de travail les plus pertinentes en fonction des anomalies remontées,</em>
        <em>- Enregistrer le temps de travail (début de service, début de secteur, pause, fin de secteur, fin de service),</em>
        <em>- Identifier les opérateurs qui réalisent les tournées afin de leur attribuer des demandes émanant directement des clients finaux en cours de journée,</em>
        <em>- Suivre la réalisation des prestations en temps réel,</em>
        <em>- Gérer la traçabilité des accès aux SI,</em>
        <em>- Gérer les tournées et les anomalies remontées,</em>
        <em>- Réaliser la synthèse des données relatives aux opérateurs, tournées et anomalies dans des rapports Power BI à destination des clients finaux,</em>
        <em>- Créer des comptes utilisateurs d’opérateurs et de maîtrises sur le portail de l’application.</em>
      </div>
    La base légale du traitement est fondée sur l’intérêt légitime du Responsable de Traitement. Les traitements de données à caractère personnel permettront notamment d’organiser et d’optimiser les tournées. Ils permettront également au Responsable de traitement d’apporter la preuve, auprès des clients collectivités, de l’exécution des prestations et de la survenance des évènements de tournées.
      Les données relatives aux accès aux SI sont traitées sur la base de l’intérêt légitime de sécurisation de l’accès aux données.

    Les catégories de données personnelles collectées directement par Suez Recyclage et Valorisation France sont les suivantes :
    <div style="margin-left: 4%" class="list-container">
        - Etat civil (Nom, prénom)
        - Vie professionnelle (poste, adresse mail professionnelle)
        - Données relatives au temps de travail (début de service, début de secteur, pause, fin de secteur, fin de service)
        - Données relatives à l’utilisation des systèmes d’information (identifiants et logs de connexion)
        - Données relatives à l’activité des tournées (immatriculation et géolocalisation des smartphones, activités des opérateurs et des évènements de tournées, photos des anomalies)
        - Données relatives aux prestations clients (nom des clients)
      </div>
    <strong>Attention, Il est à noter que conformément aux règles d’utilisation, les collaborateurs devront déposer à la fin de chaque tournée et sur leur site d’activité, le smartphone utilisé après avoir clôturé la tournée dans l’application mobile. Dans le cas où, le collaborateur aurait oublié le dépôt du smartphone, celui-ci devra impérativement clôturer leur tournée dans l’application afin d’arrêter le service de géolocalisation.</strong>
    <br><br>
    Les personnes concernées par ces traitements sont les collaborateurs du Responsable de Traitement ainsi que les collaborateurs des co-traitants et des sous-traitants du Responsable de Traitement.

    Le traitement ne prévoit pas de prise de décision automatisée.

    Pour les zones libres commentaires, il est vivement recommandé d’éviter toute communication de toute donnée à caractère personnel via ces zones de texte ou en tout état de cause de limiter cette communication à ce qui est strictement nécessaire au traitement de la demande de l’Utilisateur.

    Afin de réaliser la mise en œuvre du traitement, SUEZ s’appuie sur des sous-traitants tels que prestataires techniques. Ces sous-traitants pourront avoir accès aux catégories de données personnelles décrites ci-dessus afin de remplir leurs obligations contractuelles.

    Les données personnelles collectées sont exclusivement destinées à Suez RV France pour le compte de ses filiales, ses prestataires et ses clients.

    Les données relatives aux tournées et aux actions réalisées par un collaborateur lors de sa tournée sont conservées 18 mois.
    Les données relatives aux accès des utilisateurs à l’application mobile ou du portail sont conservées sur toute la durée d’utilisation de l’application mobile ou du portail par la personne en question.

    Vous disposez d’un droit d’accès, de rectification, de limitation, d’opposition, à la portabilité et d’un droit à l’oubli, conformément à la réglementation applicable. Vous pouvez les exercer auprès de votre coordinateur local Cantonnier. Pour plus d’informations : <a href="https://www.cnil.fr/fr/les-droits-pour-maitriser-vos-données-personnelles" target="_blank" style="color: #0080ff">https://www.cnil.fr/fr/les-droits-pour-maitriser-vos-données-personnelles</a>.

    En cas de difficulté concernant la gestion de vos données personnelles, vous pouvez contacter le Délégué à la Protection des Données de SUEZ RV France (DPO) par courriel sur <a href="mailto:privacy.france@suez.com" target="_blank" style="color: #0080ff">privacy.france@suez.com</a>. Ou par courrier postal adressé à DPO Suez France – Service Cantonniers - Suez RVF, Tour CB21, 16 Place de l’Iris, 92040, Paris La Défense Cedex.
    Si vous estimez que la réponse du DPO ne vous donne pas satisfaction, vous pouvez déposer une réclamation par courrier auprès de la Commission Nationale Informatique et Libertés, 3 Place de Fontenoy - TSA 80715 - 75334 PARIS CEDEX 07.`,
    };
  },
  methods: {
    formatPrivacyPolicyText(text) {
      return text.replace(/\n/g, "<br>");
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  padding: 20px;
  margin: 0px auto; /* Center the container horizontally and add some vertical margin */
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 8px; /* Increase border-radius for a rounded look */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add a subtle box-shadow */
}

.title {
  font-size: 25px;
  color: black;
  margin-bottom: 10px;
  font-family: DinRegular;
  text-align: center;
}

.privacy-policy-text {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  font-family: DinRegular;
}

.list-container {
  margin-left: 20px; /* Add left margin for indentation */
}

a {
  color: #0080ff; /* Set link color to blue */
}
</style>



// WEBPACK FOOTER //
// Rgpd.vue?44a18086